import crashlytics from '@react-native-firebase/crashlytics';
import React from 'react';
/**
 * 최상위 JS 렌더 예외를 Crashlytics에 기록만 하는 report-only 바운더리.
 * fallback UI는 렌더하지 않고 children을 그대로 통과시킨다.
 * (native 크래시/ANR은 RN JS로 못 잡으므로 여기 대상 아님 — Crashlytics 네이티브가 담당.)
 */
class ErrorBoundary extends React.Component {
    componentDidCatch(error, info) {
        var _a;
        // RNFirebase v22의 log()/recordError()는 void 반환(동기 네이티브 호출) — rejection 없음.
        crashlytics().log(`ErrorBoundary caught: ${(_a = info.componentStack) !== null && _a !== void 0 ? _a : ''}`);
        crashlytics().recordError(error);
    }
    render() {
        return this.props.children;
    }
}
export default ErrorBoundary;
